// import React, { useState, useEffect } from 'react';
// import { getPayments, processPayment, refundPayment,getPaymentById } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import { useSelector } from 'react-redux';

// const PaymentReport = () => {
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('All Status');
//   const [methodFilter, setMethodFilter] = useState('All Methods');
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalPayments, setTotalPayments] = useState(0);
//   const [viewingPayment, setViewingPayment] = useState(null);
//   const [processingPayment, setProcessingPayment] = useState(null);
//   const [refundingPayment, setRefundingPayment] = useState(null);
//   const [refundAmount, setRefundAmount] = useState('');
//   const [refundReason, setRefundReason] = useState('');
//     const { token } = useSelector(state => state.user);

//   const limit = 10;

//   const fetchPayments = async (page = 1) => {
//     try {
//       setLoading(true);
      
//       const params = {
//         page,
//         limit,
//         search: searchTerm || undefined,
//         status: statusFilter !== 'All Status' ? statusFilter : undefined,
//         method: methodFilter !== 'All Methods' ? methodFilter : undefined,
//         startDate: startDate || undefined,
//         endDate: endDate || undefined
//       };

//       Object.keys(params).forEach(key => {
//         if (params[key] === undefined) {
//           delete params[key];
//         }
//       });

//       const response = await getPayments(params, token);
      
//       if (response.success) {
//         setPayments(response.payments || []);
//         setTotalPages(response.totalPages || 1);
//         setCurrentPage(response.currentPage || 1);
//         setTotalPayments(response.total || 0);
//       }
//     } catch (error) {
//       console.error('Error fetching payments:', error);
//       alert('Error fetching payments: ' + (error.response?.data?.message || error.message));
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPayments(1);
//   }, [searchTerm, statusFilter, methodFilter, startDate, endDate]);

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   const handleStatusFilterChange = (e) => {
//     setStatusFilter(e.target.value);
//   };

//   const handleMethodFilterChange = (e) => {
//     setMethodFilter(e.target.value);
//   };

//   const handleStartDateChange = (e) => {
//     setStartDate(e.target.value);
//   };

//   const handleEndDateChange = (e) => {
//     setEndDate(e.target.value);
//   };

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//       fetchPayments(page);
//     }
//   };

//   const handleExportReport = () => {
//     const headers = ['Transaction ID', 'User', 'User Email', 'User Phone', 'Amount', 'Method', 'Date', 'Time', 'Status', 'Payment Status', 'Booking'];
//     const csvData = payments.map(payment => [
//       payment.transaction,
//       payment.user,
//       payment.userEmail,
//       payment.userPhone,
//       `₹${payment.amount}`,
//       payment.method,
//       payment.date,
//       payment.time,
//       payment.status,
//       payment.paymentStatus,
//       payment.booking
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `payment-report-${new Date().toISOString().split('T')[0]}.csv`;
//     link.click();
//     window.URL.revokeObjectURL(url);
    
//     alert('Payment report exported successfully!');
//   };

//   const handleViewPayment = async (payment) => {
//     try {
     
//       const response = await getPaymentById(payment.id, token);
      
//       if (response.success) {
//         setViewingPayment(response.data);
//       }
//     } catch (error) {
//       console.error('Error fetching payment details:', error);
//       alert('Error fetching payment details: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleProcessPayment = (payment) => {
//     setProcessingPayment(payment);
//   };

//   const handleConfirmProcess = async () => {
//     try {
//       const response = await processPayment(processingPayment.id, token);
      
//       if (response.success) {
//         alert('Payment processed successfully!');
//         setProcessingPayment(null);
//         fetchPayments(currentPage);
//       }
//     } catch (error) {
//       console.error('Error processing payment:', error);
//       alert('Error processing payment: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleRefundPayment = (payment) => {
//     setRefundingPayment(payment);
//     setRefundAmount(payment.amount);
//     setRefundReason('');
//   };

//   const handleConfirmRefund = async () => {
//     try {
//       const refundData = {
//         refundAmount: parseFloat(refundAmount),
//         reason: refundReason
//       };

//       const response = await refundPayment(refundingPayment.id, refundData, token);
      
//       if (response.success) {
//         alert('Payment refunded successfully!');
//         setRefundingPayment(null);
//         setRefundAmount('');
//         setRefundReason('');
//         fetchPayments(currentPage); 
//       }
//     } catch (error) {
//       console.error('Error refunding payment:', error);
//       alert('Error refunding payment: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const closeViewModal = () => {
//     setViewingPayment(null);
//   };

//   const closeProcessModal = () => {
//     setProcessingPayment(null);
//   };

//   const closeRefundModal = () => {
//     setRefundingPayment(null);
//     setRefundAmount('');
//     setRefundReason('');
//   };

//   const totalRevenue = payments
//     .filter(p => p.paymentStatus === 'success' || p.status === 'Confirmed')
//     .reduce((sum, payment) => sum + payment.amount, 0);

//   const successfulPayments = payments.filter(p => 
//     p.paymentStatus === 'success' || p.status === 'Confirmed'
//   ).length;

//   const refundAmountTotal = payments
//     .filter(p => p.status === 'Refunded' || p.status === 'cancelled')
//     .reduce((sum, payment) => sum + (payment.refundAmount || payment.amount), 0);

//   const successRate = totalPayments > 0 ? Math.round((successfulPayments / totalPayments) * 100) : 0;

//   const formatCurrency = (amount) => {
//     return `₹${amount?.toLocaleString() || '0'}`;
//   };

//   const getStatusBadgeClass = (status, paymentStatus) => {
//     if (status === 'Refunded' || status === 'cancelled') return 'refunded';
//     if (paymentStatus === 'success' || status === 'Confirmed') return 'completed';
//     if (paymentStatus === 'pending' || status === 'pending') return 'pending';
//     if (paymentStatus === 'failed') return 'failed';
//     return 'pending';
//   };

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Payment Report</h1>
//         <div className="header-actions">
//           <input 
//             type="text" 
//             placeholder="Search by transaction, user or booking..." 
//             className="search-input" 
//             value={searchTerm}
//             onChange={handleSearchChange}
//           />
//           <select 
//             className="filter-select" 
//             value={statusFilter}
//             onChange={handleStatusFilterChange}
//           >
//             <option>All Status</option>
//             <option>Completed</option>
//             <option>Pending</option>
//             <option>Failed</option>
//             <option>Refunded</option>
//           </select>
//           <select 
//             className="filter-select" 
//             value={methodFilter}
//             onChange={handleMethodFilterChange}
//           >
//             <option>All Methods</option>
//             <option>Online</option>
//             <option>Cash</option>
//             <option>Card</option>
//             <option>UPI</option>
//           </select>
//           <input
//             type="date"
//             className="filter-select"
//             value={startDate}
//             onChange={handleStartDateChange}
//             placeholder="Start Date"
//           />
//           <input
//             type="date"
//             className="filter-select"
//             value={endDate}
//             onChange={handleEndDateChange}
//             placeholder="End Date"
//           />
//           <button className="export-btn" onClick={handleExportReport}>
//             Export Report
//           </button>
//         </div>
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Revenue</h3>
//           <p>{formatCurrency(totalRevenue)}</p>
//           <span>successful payments</span>
//         </div>
//         <div className="stat-card">
//           <h3>Success Rate</h3>
//           <p>{successRate}%</p>
//           <span>{successfulPayments}/{totalPayments} payments</span>
//         </div>
//         <div className="stat-card">
//           <h3>Refunds</h3>
//           <p>{formatCurrency(refundAmountTotal)}</p>
//           <span>total refunded</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{payments.length}</p>
//           <span>payments found</span>
//         </div>
//       </div>

//       <div className="table-container">
//         {loading ? (
//           <div className="loading">Loading payments...</div>
//         ) : (
//           <>
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>Transaction ID</th>
//                   <th>User</th>
//                   <th>Amount</th>
//                   <th>Method</th>
//                   <th>Date & Time</th>
//                   <th>Booking</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {payments.map(payment => (
//                   <tr key={payment.id}>
//                     <td className="transaction">{payment.transaction}</td>
//                     <td>
//                       <div>
//                         <div>{payment.user}</div>
//                         <div className="phone">{payment.userEmail}</div>
//                       </div>
//                     </td>
//                     <td>{formatCurrency(payment.amount)}</td>
//                     <td>
//                       <span className={`payment-method ${payment.method?.toLowerCase().replace(' ', '-')}`}>
//                         {payment.method}
//                       </span>
//                     </td>
//                     <td>
//                       <div>
//                         <div>{payment.date}</div>
//                         <div className="phone">{payment.time}</div>
//                       </div>
//                     </td>
//                     <td>{payment.booking}</td>
//                     <td>
//                       <span className={`status-badge ${getStatusBadgeClass(payment.status, payment.paymentStatus)}`}>
//                         {payment.status === 'Confirmed' ? 'Completed' : payment.status}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="action-buttons">
//                         <button 
//                           className="action-btn view" 
//                           onClick={() => handleViewPayment(payment)}
//                         >
//                           Details
//                         </button>
//                         {(payment.status === 'pending' || payment.paymentStatus === 'pending') && (
//                           <button 
//                             className="action-btn process" 
//                             onClick={() => handleProcessPayment(payment)}
//                           >
//                             Process
//                           </button>
//                         )}
//                         {(payment.status === 'Confirmed' || payment.paymentStatus === 'success') && (
//                           <button 
//                             className="action-btn delete" 
//                             onClick={() => handleRefundPayment(payment)}
//                           >
//                             Refund
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             {payments.length === 0 && !loading && (
//               <div className="no-data">
//                 <p>No payments found matching your search criteria.</p>
//               </div>
//             )}
//           </>
//         )}

//         {/* {totalPages > 1 && (
//           <div className="pagination">
//             <button 
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="pagination-btn"
//             >
//               Previous
//             </button>
//             <span className="pagination-info">
//               Page {currentPage} of {totalPages}
//             </span>
//             <button 
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="pagination-btn"
//             >
//               Next
//             </button>
//           </div>
//         )} */}
//       </div>

//       {viewingPayment && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Payment Details - {viewingPayment.transaction}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Transaction ID:</label>
//                   <span className="transaction">{viewingPayment.transaction}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{viewingPayment.user}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{viewingPayment.userEmail}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{viewingPayment.userPhone}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Amount:</label>
//                   <span>{formatCurrency(viewingPayment.amount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Payment Method:</label>
//                   <span className={`payment-method ${viewingPayment.method?.toLowerCase().replace(' ', '-')}`}>
//                     {viewingPayment.method}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Date:</label>
//                   <span>{viewingPayment.date}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Time:</label>
//                   <span>{viewingPayment.time}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking Reference:</label>
//                   <span>{viewingPayment.booking}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${getStatusBadgeClass(viewingPayment.status, viewingPayment.paymentStatus)}`}>
//                     {viewingPayment.status === 'Confirmed' ? 'Completed' : viewingPayment.status}
//                   </span>
//                 </div>
 
//                 {viewingPayment.bookingDetails && (
//                   <>
//                     <h4 style={{marginTop: '20px', marginBottom: '10px'}}>Booking Information</h4>
//                     <div className="detail-row">
//                       <label>Journey Date:</label>
//                       <span>{new Date(viewingPayment.bookingDetails.journeyDate).toLocaleDateString()}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Route:</label>
//                       <span>{viewingPayment.bookingDetails.from} → {viewingPayment.bookingDetails.to}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Bus Type:</label>
//                       <span>{viewingPayment.bookingDetails.busType}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Seats:</label>
//                       <span>{viewingPayment.bookingDetails.seats?.length || 0}</span>
//                     </div>
//                   </>
//                 )}

//                 {viewingPayment.bookingData && (
//                   <>
//                     <h4 style={{marginTop: '20px', marginBottom: '10px'}}>Trip Information</h4>
//                     <div className="detail-row">
//                       <label>Journey Date:</label>
//                       <span>{new Date(viewingPayment.bookingData.journeyDate).toLocaleDateString()}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Route:</label>
//                       <span>{viewingPayment.bookingData.from} → {viewingPayment.bookingData.to}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Seats:</label>
//                       <span>{viewingPayment.bookingData.seats}</span>
//                     </div>
//                   </>
//                 )}
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {processingPayment && (
//         <div className="modal-overlay" onClick={closeProcessModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Process Payment</h3>
//               <button className="modal-close-btn" onClick={closeProcessModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Transaction:</label>
//                   <span className="transaction">{processingPayment.transaction}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{processingPayment.user}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Amount:</label>
//                   <span>{formatCurrency(processingPayment.amount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking:</label>
//                   <span>{processingPayment.booking}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Current Status:</label>
//                   <span className="status-badge pending">Pending</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Action:</label>
//                   <span>Mark as Completed</span>
//                 </div>
//               </div>
//               <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#f0f9ff', borderRadius: '8px'}}>
//                 <p style={{margin: '0', color: '#0369a1', fontSize: '14px'}}>
//                   <strong>Note:</strong> This will mark the payment as completed and confirm the associated booking.
//                 </p>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeProcessModal}>
//                 Cancel
//               </button>
//               <button className="action-btn process" onClick={handleConfirmProcess}>
//                 Confirm Process
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {refundingPayment && (
//         <div className="modal-overlay" onClick={closeRefundModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Refund Payment</h3>
//               <button className="modal-close-btn" onClick={closeRefundModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Transaction:</label>
//                   <span className="transaction">{refundingPayment.transaction}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{refundingPayment.user}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Original Amount:</label>
//                   <span>{formatCurrency(refundingPayment.amount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking:</label>
//                   <span>{refundingPayment.booking}</span>
//                 </div>
                
//                 <div className="detail-row">
//                   <label>Refund Amount:</label>
//                   <input
//                     type="number"
//                     value={refundAmount}
//                     onChange={(e) => setRefundAmount(e.target.value)}
//                     placeholder="Enter refund amount"
//                     style={{padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '200px'}}
//                   />
//                 </div>
                
//                 <div className="detail-row">
//                   <label>Refund Reason:</label>
//                   <textarea
//                     value={refundReason}
//                     onChange={(e) => setRefundReason(e.target.value)}
//                     placeholder="Enter reason for refund"
//                     style={{padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '200px', minHeight: '60px'}}
//                   />
//                 </div>
//               </div>
//               <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px'}}>
//                 <p style={{margin: '0', color: '#856404', fontSize: '14px'}}>
//                   <strong>Warning:</strong> This action will cancel the booking and process a refund. This cannot be undone.
//                 </p>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeRefundModal}>
//                 Cancel
//               </button>
//               <button className="action-btn delete" onClick={handleConfirmRefund}>
//                 Confirm Refund
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PaymentReport;

// import React, { useState, useEffect } from 'react';
// import { getPayments, processPayment, refundPayment, getPaymentById } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import { useSelector } from 'react-redux';

// const PaymentReport = () => {
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('All Status');
//   const [methodFilter, setMethodFilter] = useState('All Methods');
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalPayments, setTotalPayments] = useState(0);
//   const [viewingPayment, setViewingPayment] = useState(null);
//   const [processingPayment, setProcessingPayment] = useState(null);
//   const [refundingPayment, setRefundingPayment] = useState(null);
//   const [refundAmount, setRefundAmount] = useState('');
//   const [refundReason, setRefundReason] = useState('');
//   const { token } = useSelector(state => state.user);

//   const limit = 10;

//   const fetchPayments = async (page = 1) => {
//     try {
//       setLoading(true);
      
//       const params = {
//         page,
//         limit,
//         search: searchTerm || undefined,
//         status: statusFilter !== 'All Status' ? statusFilter : undefined,
//         method: methodFilter !== 'All Methods' ? methodFilter : undefined,
//         startDate: startDate || undefined,
//         endDate: endDate || undefined
//       };

//       // Remove undefined parameters
//       Object.keys(params).forEach(key => {
//         if (params[key] === undefined) {
//           delete params[key];
//         }
//       });

//       const response = await getPayments(params, token);
      
//       if (response.success) {
//         setPayments(response.payments || []);
//         setTotalPages(response.totalPages || 1);
//         setCurrentPage(response.currentPage || 1);
//         setTotalPayments(response.total || 0);
//       }
//     } catch (error) {
//       console.error('Error fetching payments:', error);
//       alert('Error fetching payments: ' + (error.response?.data?.message || error.message));
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     setCurrentPage(1); // Reset to first page when filters change
//     fetchPayments(1);
//   }, [searchTerm, statusFilter, methodFilter, startDate, endDate]);

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   const handleStatusFilterChange = (e) => {
//     setStatusFilter(e.target.value);
//   };

//   const handleMethodFilterChange = (e) => {
//     setMethodFilter(e.target.value);
//   };

//   const handleStartDateChange = (e) => {
//     setStartDate(e.target.value);
//   };

//   const handleEndDateChange = (e) => {
//     setEndDate(e.target.value);
//   };

//   // Pagination handlers
//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       const nextPage = currentPage + 1;
//       setCurrentPage(nextPage);
//       fetchPayments(nextPage);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       const prevPage = currentPage - 1;
//       setCurrentPage(prevPage);
//       fetchPayments(prevPage);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//       fetchPayments(pageNumber);
//     }
//   };

//   const handleExportReport = () => {
//     const headers = ['Transaction ID', 'User', 'User Email', 'User Phone', 'Amount', 'Method', 'Date', 'Time', 'Status', 'Payment Status', 'Booking'];
//     const csvData = payments.map(payment => [
//       payment.transaction,
//       payment.user,
//       payment.userEmail,
//       payment.userPhone,
//       `₹${payment.amount}`,
//       payment.method,
//       payment.date,
//       payment.time,
//       payment.status,
//       payment.paymentStatus,
//       payment.booking
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `payment-report-${new Date().toISOString().split('T')[0]}.csv`;
//     link.click();
//     window.URL.revokeObjectURL(url);
    
//     alert('Payment report exported successfully!');
//   };

//   const handleViewPayment = async (payment) => {
//     try {
//       const response = await getPaymentById(payment.id, token);
      
//       if (response.success) {
//         setViewingPayment(response.data);
//       }
//     } catch (error) {
//       console.error('Error fetching payment details:', error);
//       alert('Error fetching payment details: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleProcessPayment = (payment) => {
//     setProcessingPayment(payment);
//   };

//   const handleConfirmProcess = async () => {
//     try {
//       const response = await processPayment(processingPayment.id, token);
      
//       if (response.success) {
//         alert('Payment processed successfully!');
//         setProcessingPayment(null);
//         fetchPayments(currentPage);
//       }
//     } catch (error) {
//       console.error('Error processing payment:', error);
//       alert('Error processing payment: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleRefundPayment = (payment) => {
//     setRefundingPayment(payment);
//     setRefundAmount(payment.amount);
//     setRefundReason('');
//   };

//   const handleConfirmRefund = async () => {
//     try {
//       const refundData = {
//         refundAmount: parseFloat(refundAmount),
//         reason: refundReason
//       };

//       const response = await refundPayment(refundingPayment.id, refundData, token);
      
//       if (response.success) {
//         alert('Payment refunded successfully!');
//         setRefundingPayment(null);
//         setRefundAmount('');
//         setRefundReason('');
//         fetchPayments(currentPage); 
//       }
//     } catch (error) {
//       console.error('Error refunding payment:', error);
//       alert('Error refunding payment: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const closeViewModal = () => {
//     setViewingPayment(null);
//   };

//   const closeProcessModal = () => {
//     setProcessingPayment(null);
//   };

//   const closeRefundModal = () => {
//     setRefundingPayment(null);
//     setRefundAmount('');
//     setRefundReason('');
//   };

//   const handleRefresh = () => {
//     setCurrentPage(1);
//     fetchPayments(1);
//   };

//   const totalRevenue = payments
//     .filter(p => p.paymentStatus === 'success' || p.status === 'Confirmed')
//     .reduce((sum, payment) => sum + payment.amount, 0);

//   const successfulPayments = payments.filter(p => 
//     p.paymentStatus === 'success' || p.status === 'Confirmed'
//   ).length;

//   const refundAmountTotal = payments
//     .filter(p => p.status === 'Refunded' || p.status === 'cancelled')
//     .reduce((sum, payment) => sum + (payment.refundAmount || payment.amount), 0);

//   const successRate = totalPayments > 0 ? Math.round((successfulPayments / totalPayments) * 100) : 0;

//   const formatCurrency = (amount) => {
//     return `₹${amount?.toLocaleString() || '0'}`;
//   };

//   const getStatusBadgeClass = (status, paymentStatus) => {
//     if (status === 'Refunded' || status === 'cancelled') return 'refunded';
//     if (paymentStatus === 'success' || status === 'Confirmed') return 'completed';
//     if (paymentStatus === 'pending' || status === 'pending') return 'pending';
//     if (paymentStatus === 'failed') return 'failed';
//     return 'pending';
//   };

//   // Generate page numbers for pagination
//   const generatePageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;
    
//     if (totalPages <= maxVisiblePages) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(i);
//       }
//     } else {
//       let start = Math.max(1, currentPage - 2);
//       let end = Math.min(totalPages, start + maxVisiblePages - 1);
      
//       if (end - start + 1 < maxVisiblePages) {
//         start = Math.max(1, end - maxVisiblePages + 1);
//       }
      
//       for (let i = start; i <= end; i++) {
//         pages.push(i);
//       }
//     }
    
//     return pages;
//   };

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Payment Report</h1>
//         <div className="header-actions">
//           <input 
//             type="text" 
//             placeholder="Search by transaction, user or booking..." 
//             className="search-input" 
//             value={searchTerm}
//             onChange={handleSearchChange}
//           />
//           <select 
//             className="filter-select" 
//             value={statusFilter}
//             onChange={handleStatusFilterChange}
//           >
//             <option>All Status</option>
//             <option>Completed</option>
//             <option>Pending</option>
//             <option>Failed</option>
//             <option>Refunded</option>
//           </select>
//           <select 
//             className="filter-select" 
//             value={methodFilter}
//             onChange={handleMethodFilterChange}
//           >
//             <option>All Methods</option>
//             <option>Online</option>
//             <option>Cash</option>
//             <option>Card</option>
//             <option>UPI</option>
//           </select>
//           <input
//             type="date"
//             className="filter-select"
//             value={startDate}
//             onChange={handleStartDateChange}
//             placeholder="Start Date"
//           />
//           <input
//             type="date"
//             className="filter-select"
//             value={endDate}
//             onChange={handleEndDateChange}
//             placeholder="End Date"
//           />
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportReport}>
//             Export Report
//           </button>
//         </div>
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Payments</h3>
//           <p>{totalPayments}</p>
//           <span>All transactions</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Revenue</h3>
//           <p>{formatCurrency(totalRevenue)}</p>
//           <span>successful payments</span>
//         </div>
//         <div className="stat-card">
//           <h3>Success Rate</h3>
//           <p>{successRate}%</p>
//           <span>{successfulPayments}/{totalPayments} payments</span>
//         </div>
//         <div className="stat-card">
//           <h3>Current Page</h3>
//           <p>{payments.length}</p>
//           <span>payments displayed</span>
//         </div>
//       </div>

//       <div className="table-container">
//         {loading ? (
//           <div className="loading">Loading payments...</div>
//         ) : (
//           <>
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>Transaction ID</th>
//                   <th>User</th>
//                   <th>Amount</th>
//                   <th>Method</th>
//                   <th>Date & Time</th>
//                   <th>Booking</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {payments.map(payment => (
//                   <tr key={payment.id}>
//                     <td className="transaction">{payment.transaction}</td>
//                     <td>
//                       <div>
//                         <div>{payment.user}</div>
//                         <div className="phone">{payment.userEmail}</div>
//                       </div>
//                     </td>
//                     <td>{formatCurrency(payment.amount)}</td>
//                     <td>
//                       <span className={`payment-method ${payment.method?.toLowerCase().replace(' ', '-')}`}>
//                         {payment.method}
//                       </span>
//                     </td>
//                     <td>
//                       <div>
//                         <div>{payment.date}</div>
//                         <div className="phone">{payment.time}</div>
//                       </div>
//                     </td>
//                     <td>{payment.booking}</td>
//                     <td>
//                       <span className={`status-badge ${getStatusBadgeClass(payment.status, payment.paymentStatus)}`}>
//                         {payment.status === 'Confirmed' ? 'Completed' : payment.status}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="action-buttons">
//                         <button 
//                           className="action-btn view" 
//                           onClick={() => handleViewPayment(payment)}
//                         >
//                           Details
//                         </button>
//                         {(payment.status === 'pending' || payment.paymentStatus === 'pending') && (
//                           <button 
//                             className="action-btn process" 
//                             onClick={() => handleProcessPayment(payment)}
//                           >
//                             Process
//                           </button>
//                         )}
//                         {(payment.status === 'Confirmed' || payment.paymentStatus === 'success') && (
//                           <button 
//                             className="action-btn delete" 
//                             onClick={() => handleRefundPayment(payment)}
//                           >
//                             Refund
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             {payments.length === 0 && !loading && (
//               <div className="no-data">
//                 <p>No payments found matching your search criteria.</p>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {/* Enhanced Pagination Component */}
//       {totalPages > 1 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {payments.length} of {totalPayments} payments (Page {currentPage} of {totalPages})
//           </div>
//           <div className="pagination-controls">
//             <button 
//               className="pagination-btn" 
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>
            
//             {/* Page Numbers */}
//             <div className="page-numbers">
//               {generatePageNumbers().map(pageNumber => (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               ))}
              
//               {totalPages > 5 && currentPage < totalPages - 2 && (
//                 <>
//                   <span className="page-dots">...</span>
//                   <button
//                     className="page-number"
//                     onClick={() => handlePageClick(totalPages)}
//                   >
//                     {totalPages}
//                   </button>
//                 </>
//               )}
//             </div>
            
//             <button 
//               className="pagination-btn" 
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}

//       {viewingPayment && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Payment Details - {viewingPayment.transaction}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Transaction ID:</label>
//                   <span className="transaction">{viewingPayment.transaction}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{viewingPayment.user}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{viewingPayment.userEmail}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{viewingPayment.userPhone}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Amount:</label>
//                   <span>{formatCurrency(viewingPayment.amount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Payment Method:</label>
//                   <span className={`payment-method ${viewingPayment.method?.toLowerCase().replace(' ', '-')}`}>
//                     {viewingPayment.method}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Date:</label>
//                   <span>{viewingPayment.date}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Time:</label>
//                   <span>{viewingPayment.time}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking Reference:</label>
//                   <span>{viewingPayment.booking}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${getStatusBadgeClass(viewingPayment.status, viewingPayment.paymentStatus)}`}>
//                     {viewingPayment.status === 'Confirmed' ? 'Completed' : viewingPayment.status}
//                   </span>
//                 </div>

//                 {viewingPayment.bookingDetails && (
//                   <>
//                     <h4 style={{marginTop: '20px', marginBottom: '10px'}}>Booking Information</h4>
//                     <div className="detail-row">
//                       <label>Journey Date:</label>
//                       <span>{new Date(viewingPayment.bookingDetails.journeyDate).toLocaleDateString()}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Route:</label>
//                       <span>{viewingPayment.bookingDetails.from} → {viewingPayment.bookingDetails.to}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Bus Type:</label>
//                       <span>{viewingPayment.bookingDetails.busType}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Seats:</label>
//                       <span>{viewingPayment.bookingDetails.seats?.length || 0}</span>
//                     </div>
//                   </>
//                 )}

//                 {viewingPayment.bookingData && (
//                   <>
//                     <h4 style={{marginTop: '20px', marginBottom: '10px'}}>Trip Information</h4>
//                     <div className="detail-row">
//                       <label>Journey Date:</label>
//                       <span>{new Date(viewingPayment.bookingData.journeyDate).toLocaleDateString()}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Route:</label>
//                       <span>{viewingPayment.bookingData.from} → {viewingPayment.bookingData.to}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Seats:</label>
//                       <span>{viewingPayment.bookingData.seats}</span>
//                     </div>
//                   </>
//                 )}
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {processingPayment && (
//         <div className="modal-overlay" onClick={closeProcessModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Process Payment</h3>
//               <button className="modal-close-btn" onClick={closeProcessModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Transaction:</label>
//                   <span className="transaction">{processingPayment.transaction}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{processingPayment.user}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Amount:</label>
//                   <span>{formatCurrency(processingPayment.amount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking:</label>
//                   <span>{processingPayment.booking}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Current Status:</label>
//                   <span className="status-badge pending">Pending</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Action:</label>
//                   <span>Mark as Completed</span>
//                 </div>
//               </div>
//               <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#f0f9ff', borderRadius: '8px'}}>
//                 <p style={{margin: '0', color: '#0369a1', fontSize: '14px'}}>
//                   <strong>Note:</strong> This will mark the payment as completed and confirm the associated booking.
//                 </p>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeProcessModal}>
//                 Cancel
//               </button>
//               <button className="action-btn process" onClick={handleConfirmProcess}>
//                 Confirm Process
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {refundingPayment && (
//         <div className="modal-overlay" onClick={closeRefundModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Refund Payment</h3>
//               <button className="modal-close-btn" onClick={closeRefundModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Transaction:</label>
//                   <span className="transaction">{refundingPayment.transaction}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{refundingPayment.user}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Original Amount:</label>
//                   <span>{formatCurrency(refundingPayment.amount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking:</label>
//                   <span>{refundingPayment.booking}</span>
//                 </div>
                
//                 <div className="detail-row">
//                   <label>Refund Amount:</label>
//                   <input
//                     type="number"
//                     value={refundAmount}
//                     onChange={(e) => setRefundAmount(e.target.value)}
//                     placeholder="Enter refund amount"
//                     style={{padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '200px'}}
//                   />
//                 </div>
                
//                 <div className="detail-row">
//                   <label>Refund Reason:</label>
//                   <textarea
//                     value={refundReason}
//                     onChange={(e) => setRefundReason(e.target.value)}
//                     placeholder="Enter reason for refund"
//                     style={{padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '200px', minHeight: '60px'}}
//                   />
//                 </div>
//               </div>
//               <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px'}}>
//                 <p style={{margin: '0', color: '#856404', fontSize: '14px'}}>
//                   <strong>Warning:</strong> This action will cancel the booking and process a refund. This cannot be undone.
//                 </p>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeRefundModal}>
//                 Cancel
//               </button>
//               <button className="action-btn delete" onClick={handleConfirmRefund}>
//                 Confirm Refund
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PaymentReport;

// import React, { useState, useEffect } from 'react';
// import { getPayments, processPayment, refundPayment, getPaymentById } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import { useSelector } from 'react-redux';

// const PaymentReport = () => {
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewingPayment, setViewingPayment] = useState(null);
//   const [processingPayment, setProcessingPayment] = useState(null);
//   const [refundingPayment, setRefundingPayment] = useState(null);
//   const [refundAmount, setRefundAmount] = useState('');
//   const [refundReason, setRefundReason] = useState('');
//   const [error, setError] = useState(null);
//   const { token } = useSelector(state => state.user);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalPayments, setTotalPayments] = useState(0);
//   const [pageSize] = useState(10);

//   // Filter states
//   const [filters, setFilters] = useState({
//     status: 'All Status',
//     method: 'All Methods',
//     startDate: '',
//     endDate: '',
//     transaction: '',
//     userName: '',
//     userEmail: '',
//     userPhone: '',
//     bookingId: '',
//     minAmount: '',
//     maxAmount: ''
//   });
//   const [showFilters, setShowFilters] = useState(false);
//   const [isFiltered, setIsFiltered] = useState(false);

//   // Fetch payments with all filters
//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchPayments();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm, filters]);

// const fetchPayments = async () => {
//   try {
//     setSearching(true);
//     setLoading(true);
//     setError(null);
      
//       // Prepare filter parameters for API
//       const filterParams = {};
      
//       // Add search term to filters
//       if (searchTerm) {
//         filterParams.search = searchTerm;
//       }
      
//       // Add other filters (only if not default values)
//       Object.keys(filters).forEach(key => {
//         if (filters[key] && filters[key] !== 'All Status' && filters[key] !== 'All Methods') {
//           filterParams[key] = filters[key];
//         }
//       });

//       // Add pagination
//       const params = {
//         page: currentPage,
//         limit: pageSize,
//         ...filterParams
//       };

//       console.log('Fetching payments with params:', params);

//       const response = await getPayments(params, token);
      
//       if (response && response.success) {
//         console.log('Payments response:', response);
        
//         // Format payments to ensure consistent structure
//         const formattedPayments = response.payments.map(payment => ({
//           id: payment.id,
//           transaction: payment.transaction || `TXN${payment.id?.slice(-8) || 'N/A'}`,
//           user: payment.user || 'N/A',
//           userEmail: payment.userEmail || 'N/A',
//           userPhone: payment.userPhone || 'N/A',
//           amount: payment.amount || 0,
//           method: payment.method || 'Online',
//           date: payment.date || 'N/A',
//           time: payment.time || 'N/A',
//           booking: payment.booking || 'N/A',
//           status: payment.status || 'pending',
//           paymentStatus: payment.paymentStatus || payment.status || 'pending',
//           // Keep raw data for modal
//           rawData: payment
//         }));

//         setPayments(formattedPayments);
//         setTotalPages(response.totalPages || 1);
//         setTotalPayments(response.total || 0);
        
//         // Check if any filter is active
//         const hasActiveFilters = 
//           filters.status !== 'All Status' || 
//           filters.method !== 'All Methods' || 
//           searchTerm !== '' || 
//           Object.values(filters).some(value => 
//             value && value !== '' && value !== 'All Status' && value !== 'All Methods'
//           );
//         setIsFiltered(hasActiveFilters);
//       } else {
//         setError('Failed to fetch payments.');
//         setPayments([]);
//       }
//     } catch (err) {
//       console.error('Error fetching payments:', err);
//       setError('Failed to fetch payments. Please try again.');
//       setPayments([]);
//    } finally {
//   setLoading(false);
//   setSearching(false);
// }
//   };

//   // Safe accessor functions
//   const getSafeString = (value) => {
//     if (value === null || value === undefined) return '';
//     return String(value);
//   };

//   const getSafeLowerCase = (value) => {
//     if (value === null || value === undefined) return '';
//     return String(value).toLowerCase();
//   };

//   const getSafeNumber = (value) => {
//     if (value === null || value === undefined) return 0;
//     return Number(value);
//   };

//   // Filter handlers
//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     setCurrentPage(1);
//     fetchPayments();
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const applyFilters = () => {
//     setCurrentPage(1);
//     fetchPayments();
//     setShowFilters(false);
//   };

//   const clearFilters = () => {
//     setFilters({
//       status: 'All Status',
//       method: 'All Methods',
//       startDate: '',
//       endDate: '',
//       transaction: '',
//       userName: '',
//       userEmail: '',
//       userPhone: '',
//       bookingId: '',
//       minAmount: '',
//       maxAmount: ''
//     });
//     setSearchTerm('');
//     setCurrentPage(1);
//     setIsFiltered(false);
//   };

//   // Export CSV function
//   const handleExportReport = () => {
//     if (payments.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Transaction ID', 'User', 'Email', 'Phone', 'Amount', 'Method', 'Date', 'Time', 'Booking ID', 'Status'];
//     const csvData = payments.map(payment => [
//       payment.transaction || '',
//       payment.user || '',
//       payment.userEmail || '',
//       payment.userPhone || '',
//       `₹${payment.amount || 0}`,
//       payment.method || '',
//       payment.date || '',
//       payment.time || '',
//       payment.booking || '',
//       payment.status || ''
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `payments-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('Payment report exported successfully!');
//   };

//   const handleViewPayment = async (payment) => {
//     try {
//       const response = await getPaymentById(payment.id, token);
      
//       if (response.success) {
//         const paymentData = response.data || response.payment;
//         setViewingPayment({
//           ...payment,
//           // Override with detailed data if available
//           ...paymentData,
//           // Ensure required fields
//           transaction: paymentData?.transaction || payment.transaction,
//           user: paymentData?.user || payment.user,
//           userEmail: paymentData?.userEmail || payment.userEmail,
//           userPhone: paymentData?.userPhone || payment.userPhone,
//           amount: paymentData?.amount || payment.amount,
//           method: paymentData?.method || payment.method,
//           date: paymentData?.date || payment.date,
//           time: paymentData?.time || payment.time,
//           status: paymentData?.status || payment.status,
//           paymentStatus: paymentData?.paymentStatus || payment.paymentStatus,
//           booking: paymentData?.booking || payment.booking
//         });
//       }
//     } catch (error) {
//       console.error('Error fetching payment details:', error);
//       // Use existing data if API fails
//       setViewingPayment(payment);
//     }
//   };

//   const handleProcessPayment = (payment) => {
//     setProcessingPayment(payment);
//   };

//   const handleConfirmProcess = async () => {
//     try {
//       const response = await processPayment(processingPayment.id, token);
      
//       if (response.success) {
//         alert('Payment processed successfully!');
//         setProcessingPayment(null);
//         fetchPayments();
//       }
//     } catch (error) {
//       console.error('Error processing payment:', error);
//       alert('Error processing payment: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleRefundPayment = (payment) => {
//     setRefundingPayment(payment);
//     setRefundAmount(payment.amount);
//     setRefundReason('');
//   };

//   const handleConfirmRefund = async () => {
//     try {
//       const refundData = {
//         refundAmount: parseFloat(refundAmount),
//         reason: refundReason
//       };

//       const response = await refundPayment(refundingPayment.id, refundData, token);
      
//       if (response.success) {
//         alert('Payment refunded successfully!');
//         setRefundingPayment(null);
//         setRefundAmount('');
//         setRefundReason('');
//         fetchPayments();
//       }
//     } catch (error) {
//       console.error('Error refunding payment:', error);
//       alert('Error refunding payment: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const closeViewModal = () => {
//     setViewingPayment(null);
//   };

//   const closeProcessModal = () => {
//     setProcessingPayment(null);
//   };

//   const closeRefundModal = () => {
//     setRefundingPayment(null);
//     setRefundAmount('');
//     setRefundReason('');
//   };

// const handleRefresh = () => {
//   setSearchTerm('');
//   setCurrentPage(1);
//   clearFilters();
//   // The useEffect will trigger fetchPayments automatically
// };

//   // Pagination handlers
//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Calculate stats
//   const totalRevenue = payments
//     .filter(p => getSafeLowerCase(p.paymentStatus) === 'success' || getSafeLowerCase(p.status) === 'confirmed')
//     .reduce((sum, payment) => sum + getSafeNumber(payment.amount), 0);

//   const successfulPayments = payments.filter(p => 
//     getSafeLowerCase(p.paymentStatus) === 'success' || getSafeLowerCase(p.status) === 'confirmed'
//   ).length;

//   const refundAmountTotal = payments
//     .filter(p => getSafeLowerCase(p.status) === 'refunded' || getSafeLowerCase(p.status) === 'cancelled')
//     .reduce((sum, payment) => sum + getSafeNumber(payment.amount), 0);

//   const successRate = totalPayments > 0 ? Math.round((successfulPayments / totalPayments) * 100) : 0;

//   const formatCurrency = (amount) => {
//     return `₹${getSafeNumber(amount).toLocaleString()}`;
//   };

//   const getStatusBadgeClass = (status, paymentStatus) => {
//     const lowerStatus = getSafeLowerCase(status);
//     const lowerPaymentStatus = getSafeLowerCase(paymentStatus);
    
//     if (lowerStatus === 'refunded' || lowerStatus === 'cancelled') return 'refunded';
//     if (lowerPaymentStatus === 'success' || lowerStatus === 'confirmed') return 'completed';
//     if (lowerPaymentStatus === 'pending' || lowerStatus === 'pending') return 'pending';
//     if (lowerPaymentStatus === 'failed') return 'failed';
//     return 'pending';
//   };

//   // Generate page numbers
//   const generatePageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;
    
//     if (totalPages <= maxVisiblePages) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(i);
//       }
//     } else {
//       let start = Math.max(1, currentPage - 2);
//       let end = Math.min(totalPages, start + maxVisiblePages - 1);
      
//       if (end - start + 1 < maxVisiblePages) {
//         start = Math.max(1, end - maxVisiblePages + 1);
//       }
      
//       for (let i = start; i <= end; i++) {
//         pages.push(i);
//       }
//     }
    
//     return pages;
//   };

//  if (loading && payments.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <p>Loading payments...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Payment Report</h1>
//         <div className="header-actions">
//         <form onSubmit={handleSearchSubmit} className="search-form">
//   <div style={{ position: 'relative' }}>
//     <input 
//       type="text" 
//       placeholder="Search by transaction or booking..." 
//       className="search-input" 
//       value={searchTerm}
//       onChange={handleSearchChange}
//       style={{ width: "70%" }}
//     />
//     {searching && (
//       <span style={{
//         position: 'absolute', right: '10px', top: '50%',
//         transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//       }}>
//         searching...
//       </span>
//     )}
//   </div>
// </form>
         
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportReport}>
//             Export Report
//           </button>
//         </div>
//       </div>

//       {/* Filter Panel */}
//       {showFilters && (
//         <div className="filter-panel">
//           <div className="filter-header">
//             <h3>Filter Payments</h3>
//             <button className="close-filters" onClick={() => setShowFilters(false)}>
//               ×
//             </button>
//           </div>
//           <div className="filter-grid">
//             <div className="filter-group">
//               <label>Transaction ID</label>
//               <input
//                 type="text"
//                 name="transaction"
//                 value={filters.transaction}
//                 onChange={handleFilterChange}
//                 placeholder="Enter transaction ID"
//               />
//             </div>
//             <div className="filter-group">
//               <label>User Name</label>
//               <input
//                 type="text"
//                 name="userName"
//                 value={filters.userName}
//                 onChange={handleFilterChange}
//                 placeholder="Enter user name"
//               />
//             </div>
//             <div className="filter-group">
//               <label>User Email</label>
//               <input
//                 type="email"
//                 name="userEmail"
//                 value={filters.userEmail}
//                 onChange={handleFilterChange}
//                 placeholder="Enter user email"
//               />
//             </div>
//             <div className="filter-group">
//               <label>User Phone</label>
//               <input
//                 type="text"
//                 name="userPhone"
//                 value={filters.userPhone}
//                 onChange={handleFilterChange}
//                 placeholder="Enter user phone"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Booking ID</label>
//               <input
//                 type="text"
//                 name="bookingId"
//                 value={filters.bookingId}
//                 onChange={handleFilterChange}
//                 placeholder="Enter booking ID"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Payment Status</label>
//               <select
//                 name="status"
//                 value={filters.status}
//                 onChange={handleFilterChange}
//               >
//                 <option value="All Status">All Status</option>
//                 <option value="Completed">Completed</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Failed">Failed</option>
//                 <option value="Refunded">Refunded</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Payment Method</label>
//               <select
//                 name="method"
//                 value={filters.method}
//                 onChange={handleFilterChange}
//               >
//                 <option value="All Methods">All Methods</option>
//                 <option value="Online">Online</option>
//                 <option value="Cash">Cash</option>
//                 <option value="Card">Card</option>
//                 <option value="UPI">UPI</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Payment From</label>
//               <input
//                 type="date"
//                 name="startDate"
//                 value={filters.startDate}
//                 onChange={handleFilterChange}
//               />
//             </div>
//             <div className="filter-group">
//               <label>Payment To</label>
//               <input
//                 type="date"
//                 name="endDate"
//                 value={filters.endDate}
//                 onChange={handleFilterChange}
//               />
//             </div>
//             <div className="filter-group">
//               <label>Min Amount</label>
//               <input
//                 type="number"
//                 name="minAmount"
//                 value={filters.minAmount}
//                 onChange={handleFilterChange}
//                 placeholder="Minimum amount"
//                 min="0"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Max Amount</label>
//               <input
//                 type="number"
//                 name="maxAmount"
//                 value={filters.maxAmount}
//                 onChange={handleFilterChange}
//                 placeholder="Maximum amount"
//                 min="0"
//               />
//             </div>
//           </div>
//           <div className="filter-actions">
//             <button className="apply-filters-btn" onClick={applyFilters}>
//               Apply Filters
//             </button>
//             <button className="clear-filters-btn" onClick={clearFilters}>
//               Clear All
//             </button>
//           </div>
//           {isFiltered && (
//             <div className="active-filters">
//               <span>Active Filters:</span>
//               {searchTerm && (
//                 <span className="filter-tag">Search: {searchTerm}</span>
//               )}
//               {filters.status !== 'All Status' && (
//                 <span className="filter-tag">Status: {filters.status}</span>
//               )}
//               {filters.method !== 'All Methods' && (
//                 <span className="filter-tag">Method: {filters.method}</span>
//               )}
//               {Object.entries(filters).map(([key, value]) => 
//                 value && 
//                 key !== 'status' && 
//                 key !== 'method' && 
//                 key !== 'startDate' && 
//                 key !== 'endDate' && (
//                   <span key={key} className="filter-tag">
//                     {key}: {value}
//                   </span>
//                 )
//               )}
//               {filters.startDate && (
//                 <span className="filter-tag">From: {filters.startDate}</span>
//               )}
//               {filters.endDate && (
//                 <span className="filter-tag">To: {filters.endDate}</span>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Payments</h3>
//           <p>{totalPayments}</p>
//           <span>All transactions</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Revenue</h3>
//           <p>{formatCurrency(totalRevenue)}</p>
//           <span>successful payments</span>
//         </div>
//         <div className="stat-card">
//           <h3>Success Rate</h3>
//           <p>{successRate}%</p>
//           <span>{successfulPayments}/{totalPayments} payments</span>
//         </div>
// <div className="stat-card">
//   <h3>Search Results</h3>
//   <p>{payments.length}</p>
//   <span>payments found</span>
// </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>Transaction ID</th>
//               <th>User</th>
//               <th>Amount</th>
//               <th>Method</th>
//               <th>Date & Time</th>
//               <th>Booking</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
// <tbody>
//   {payments.length > 0 ? (
//     payments.map(payment => (
//                 <tr key={payment.id}>
//                   <td className="transaction">{getSafeString(payment.transaction)}</td>
//                   <td>
//                     <div>
//                       <div>{getSafeString(payment.user)}</div>
//                       <div className="phone">{getSafeString(payment.userEmail)}</div>
//                     </div>
//                   </td>
//                   <td>{formatCurrency(payment.amount)}</td>
//                   <td>
//                     <span className={`payment-method ${getSafeLowerCase(payment.method).replace(' ', '-')}`}>
//                       {getSafeString(payment.method)}
//                     </span>
//                   </td>
//                   <td>
//                     <div>
//                       <div>{getSafeString(payment.date)}</div>
//                       <div className="phone">{getSafeString(payment.time)}</div>
//                     </div>
//                   </td>
//                   <td>{getSafeString(payment.booking)}</td>
//                   <td>
//                     <span className={`status-badge ${getStatusBadgeClass(payment.status, payment.paymentStatus)}`}>
//                       {getSafeString(payment.status === 'Confirmed' ? 'Completed' : payment.status)}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="action-buttons">
//                       <button 
//                         className="action-btn view" 
//                         onClick={() => handleViewPayment(payment)}
//                       >
//                         Details
//                       </button>
//                       {(getSafeLowerCase(payment.status) === 'pending' || getSafeLowerCase(payment.paymentStatus) === 'pending') && (
//                         <button 
//                           className="action-btn process" 
//                           onClick={() => handleProcessPayment(payment)}
//                         >
//                           Process
//                         </button>
//                       )}
//                       {(getSafeLowerCase(payment.status) === 'confirmed' || getSafeLowerCase(payment.paymentStatus) === 'success') && (
//                         <button 
//                           className="action-btn delete" 
//                           onClick={() => handleRefundPayment(payment)}
//                         >
//                           Refund
//                         </button>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="no-data">
//                   <p>No payments found {isFiltered ? 'matching your filters' : ''}.</p>
//                   {isFiltered && (
//                     <button className="clear-filters-link" onClick={clearFilters}>
//                       Clear filters to see all payments
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination Component */}
//       {totalPages > 1 && (
//         <div className="pagination-container">
// <div className="pagination-info">
//   Showing {payments.length} of {totalPayments} payments
//   (Page {currentPage} of {totalPages})
//   {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//   {isFiltered && !searchTerm && <span className="filtered-indicator"> • Filtered Results</span>}
// </div>
//           <div className="pagination-controls">
//             <button 
//               className="pagination-btn" 
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>
            
//             {/* Page Numbers */}
//             <div className="page-numbers">
//               {generatePageNumbers().map(pageNumber => (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               ))}
              
//               {totalPages > 5 && currentPage < totalPages - 2 && (
//                 <>
//                   <span className="page-dots">...</span>
//                   <button
//                     className="page-number"
//                     onClick={() => handlePageClick(totalPages)}
//                   >
//                     {totalPages}
//                   </button>
//                 </>
//               )}
//             </div>
            
//             <button 
//               className="pagination-btn" 
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Modals (same as before, but using safe accessors) */}
//       {viewingPayment && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Payment Details - {getSafeString(viewingPayment.transaction)}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Transaction ID:</label>
//                   <span className="transaction">{getSafeString(viewingPayment.transaction)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{getSafeString(viewingPayment.user)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{getSafeString(viewingPayment.userEmail)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{getSafeString(viewingPayment.userPhone)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Amount:</label>
//                   <span>{formatCurrency(viewingPayment.amount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Payment Method:</label>
//                   <span className={`payment-method ${getSafeLowerCase(viewingPayment.method).replace(' ', '-')}`}>
//                     {getSafeString(viewingPayment.method)}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Date:</label>
//                   <span>{getSafeString(viewingPayment.date)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Time:</label>
//                   <span>{getSafeString(viewingPayment.time)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking Reference:</label>
//                   <span>{getSafeString(viewingPayment.booking)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${getStatusBadgeClass(viewingPayment.status, viewingPayment.paymentStatus)}`}>
//                     {getSafeString(viewingPayment.status === 'Confirmed' ? 'Completed' : viewingPayment.status)}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Process Payment Modal */}
//       {processingPayment && (
//         <div className="modal-overlay" onClick={closeProcessModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Process Payment</h3>
//               <button className="modal-close-btn" onClick={closeProcessModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Transaction:</label>
//                   <span className="transaction">{getSafeString(processingPayment.transaction)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{getSafeString(processingPayment.user)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Amount:</label>
//                   <span>{formatCurrency(processingPayment.amount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking:</label>
//                   <span>{getSafeString(processingPayment.booking)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Current Status:</label>
//                   <span className="status-badge pending">Pending</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Action:</label>
//                   <span>Mark as Completed</span>
//                 </div>
//               </div>
//               <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#f0f9ff', borderRadius: '8px'}}>
//                 <p style={{margin: '0', color: '#0369a1', fontSize: '14px'}}>
//                   <strong>Note:</strong> This will mark the payment as completed and confirm the associated booking.
//                 </p>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeProcessModal}>
//                 Cancel
//               </button>
//               <button className="action-btn process" onClick={handleConfirmProcess}>
//                 Confirm Process
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Refund Payment Modal */}
//       {refundingPayment && (
//         <div className="modal-overlay" onClick={closeRefundModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Refund Payment</h3>
//               <button className="modal-close-btn" onClick={closeRefundModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Transaction:</label>
//                   <span className="transaction">{getSafeString(refundingPayment.transaction)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>User:</label>
//                   <span>{getSafeString(refundingPayment.user)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Original Amount:</label>
//                   <span>{formatCurrency(refundingPayment.amount)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Booking:</label>
//                   <span>{getSafeString(refundingPayment.booking)}</span>
//                 </div>
                
//                 <div className="detail-row">
//                   <label>Refund Amount:</label>
//                   <input
//                     type="number"
//                     value={refundAmount}
//                     onChange={(e) => setRefundAmount(e.target.value)}
//                     placeholder="Enter refund amount"
//                     style={{padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '200px'}}
//                   />
//                 </div>
                
//                 <div className="detail-row">
//                   <label>Refund Reason:</label>
//                   <textarea
//                     value={refundReason}
//                     onChange={(e) => setRefundReason(e.target.value)}
//                     placeholder="Enter reason for refund"
//                     style={{padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '200px', minHeight: '60px'}}
//                   />
//                 </div>
//               </div>
//               <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px'}}>
//                 <p style={{margin: '0', color: '#856404', fontSize: '14px'}}>
//                   <strong>Warning:</strong> This action will cancel the booking and process a refund. This cannot be undone.
//                 </p>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeRefundModal}>
//                 Cancel
//               </button>
//               <button className="action-btn delete" onClick={handleConfirmRefund}>
//                 Confirm Refund
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PaymentReport;

import React, { useState, useEffect } from 'react';
import { getPayments, processPayment, refundPayment, getPaymentById } from '../../Services/Operations/ProductAPI';
import '../../Styles/ManagementPages.css';
import { useSelector } from 'react-redux';

// Skeleton Components
const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>Transaction ID</th>
          <th>User</th>
          <th>Amount</th>
          <th>Method</th>
          <th>Date & Time</th>
          <th>Booking</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonFilterPanel = () => (
  <div className="filter-panel skeleton">
    <div className="filter-header">
      <div className="skeleton-title"></div>
      <div className="skeleton-close"></div>
    </div>
    <div className="filter-grid">
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
        <div key={i} className="filter-group">
          <div className="skeleton-label"></div>
          <div className="skeleton-input"></div>
        </div>
      ))}
    </div>
    <div className="filter-actions">
      <div className="skeleton-button"></div>
      <div className="skeleton-button"></div>
    </div>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
          <div key={i} className="skeleton-detail-row">
            <div className="skeleton-label"></div>
            <div className="skeleton-value"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const PaymentReport = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewingPayment, setViewingPayment] = useState(null);
  const [processingPayment, setProcessingPayment] = useState(null);
  const [refundingPayment, setRefundingPayment] = useState(null);
  const [refundAmount, setRefundAmount] = useState('');
  const [refundReason, setRefundReason] = useState('');
  const [error, setError] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const { token } = useSelector(state => state.user);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPayments, setTotalPayments] = useState(0);
  const [pageSize] = useState(10);

  // Filter states
  const [filters, setFilters] = useState({
    status: 'All Status',
    method: 'All Methods',
    startDate: '',
    endDate: '',
    transaction: '',
    userName: '',
    userEmail: '',
    userPhone: '',
    bookingId: '',
    minAmount: '',
    maxAmount: ''
  });
  const [showFilters, setShowFilters] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  // Fetch payments with all filters
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchPayments();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [currentPage, searchTerm, filters]);

  const fetchPayments = async () => {
    try {
      setSearching(true);
      setLoading(true);
      setError(null);
      
      const filterParams = {};
      
      if (searchTerm) {
        filterParams.search = searchTerm;
      }
      
      Object.keys(filters).forEach(key => {
        if (filters[key] && filters[key] !== 'All Status' && filters[key] !== 'All Methods') {
          filterParams[key] = filters[key];
        }
      });

      const params = {
        page: currentPage,
        limit: pageSize,
        ...filterParams
      };

      console.log('Fetching payments with params:', params);

      const response = await getPayments(params, token);
      
      if (response && response.success) {
        console.log('Payments response:', response);
        
        const formattedPayments = response.payments.map(payment => ({
          id: payment.id,
          transaction: payment.transaction || `TXN${payment.id?.slice(-8) || 'N/A'}`,
          user: payment.user || 'N/A',
          userEmail: payment.userEmail || 'N/A',
          userPhone: payment.userPhone || 'N/A',
          amount: payment.amount || 0,
          method: payment.method || 'Online',
          date: payment.date || 'N/A',
          time: payment.time || 'N/A',
          booking: payment.booking || 'N/A',
          status: payment.status || 'pending',
          paymentStatus: payment.paymentStatus || payment.status || 'pending',
          rawData: payment
        }));

        setPayments(formattedPayments);
        setTotalPages(response.totalPages || 1);
        setTotalPayments(response.total || 0);
        
        const hasActiveFilters = 
          filters.status !== 'All Status' || 
          filters.method !== 'All Methods' || 
          searchTerm !== '' || 
          Object.values(filters).some(value => 
            value && value !== '' && value !== 'All Status' && value !== 'All Methods'
          );
        setIsFiltered(hasActiveFilters);
      } else {
        setError('Failed to fetch payments.');
        setPayments([]);
      }
    } catch (err) {
      console.error('Error fetching payments:', err);
      setError('Failed to fetch payments. Please try again.');
      setPayments([]);
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  const getSafeString = (value) => {
    if (value === null || value === undefined) return '';
    return String(value);
  };

  const getSafeLowerCase = (value) => {
    if (value === null || value === undefined) return '';
    return String(value).toLowerCase();
  };

  const getSafeNumber = (value) => {
    if (value === null || value === undefined) return 0;
    return Number(value);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchPayments();
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    setCurrentPage(1);
    fetchPayments();
    setShowFilters(false);
  };

  const clearFilters = () => {
    setFilters({
      status: 'All Status',
      method: 'All Methods',
      startDate: '',
      endDate: '',
      transaction: '',
      userName: '',
      userEmail: '',
      userPhone: '',
      bookingId: '',
      minAmount: '',
      maxAmount: ''
    });
    setSearchTerm('');
    setCurrentPage(1);
    setIsFiltered(false);
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleExportReport = () => {
    if (payments.length === 0) {
      alert('No data to export');
      return;
    }

    const headers = ['Transaction ID', 'User', 'Email', 'Phone', 'Amount', 'Method', 'Date', 'Time', 'Booking ID', 'Status'];
    const csvData = payments.map(payment => [
      payment.transaction || '',
      payment.user || '',
      payment.userEmail || '',
      payment.userPhone || '',
      `₹${payment.amount || 0}`,
      payment.method || '',
      payment.date || '',
      payment.time || '',
      payment.booking || '',
      payment.status || ''
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `payments-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    alert('Payment report exported successfully!');
  };

  const handleViewPayment = async (payment) => {
    try {
      setIsFetchingDetails(true);
      const response = await getPaymentById(payment.id, token);
      
      if (response.success) {
        const paymentData = response.data || response.payment;
        setViewingPayment({
          ...payment,
          ...paymentData,
          transaction: paymentData?.transaction || payment.transaction,
          user: paymentData?.user || payment.user,
          userEmail: paymentData?.userEmail || payment.userEmail,
          userPhone: paymentData?.userPhone || payment.userPhone,
          amount: paymentData?.amount || payment.amount,
          method: paymentData?.method || payment.method,
          date: paymentData?.date || payment.date,
          time: paymentData?.time || payment.time,
          status: paymentData?.status || payment.status,
          paymentStatus: paymentData?.paymentStatus || payment.paymentStatus,
          booking: paymentData?.booking || payment.booking
        });
      }
    } catch (error) {
      console.error('Error fetching payment details:', error);
      setViewingPayment(payment);
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleProcessPayment = (payment) => {
    setProcessingPayment(payment);
  };

  const handleConfirmProcess = async () => {
    try {
      const response = await processPayment(processingPayment.id, token);
      
      if (response.success) {
        alert('Payment processed successfully!');
        setProcessingPayment(null);
        fetchPayments();
      }
    } catch (error) {
      console.error('Error processing payment:', error);
      alert('Error processing payment: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleRefundPayment = (payment) => {
    setRefundingPayment(payment);
    setRefundAmount(payment.amount);
    setRefundReason('');
  };

  const handleConfirmRefund = async () => {
    try {
      const refundData = {
        refundAmount: parseFloat(refundAmount),
        reason: refundReason
      };

      const response = await refundPayment(refundingPayment.id, refundData, token);
      
      if (response.success) {
        alert('Payment refunded successfully!');
        setRefundingPayment(null);
        setRefundAmount('');
        setRefundReason('');
        fetchPayments();
      }
    } catch (error) {
      console.error('Error refunding payment:', error);
      alert('Error refunding payment: ' + (error.response?.data?.message || error.message));
    }
  };

  const closeViewModal = () => {
    setViewingPayment(null);
  };

  const closeProcessModal = () => {
    setProcessingPayment(null);
  };

  const closeRefundModal = () => {
    setRefundingPayment(null);
    setRefundAmount('');
    setRefundReason('');
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
    clearFilters();
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalRevenue = payments
    .filter(p => getSafeLowerCase(p.paymentStatus) === 'success' || getSafeLowerCase(p.status) === 'confirmed')
    .reduce((sum, payment) => sum + getSafeNumber(payment.amount), 0);

  const successfulPayments = payments.filter(p => 
    getSafeLowerCase(p.paymentStatus) === 'success' || getSafeLowerCase(p.status) === 'confirmed'
  ).length;

  const successRate = totalPayments > 0 ? Math.round((successfulPayments / totalPayments) * 100) : 0;

  const formatCurrency = (amount) => {
    return `₹${getSafeNumber(amount).toLocaleString()}`;
  };

  const getStatusBadgeClass = (status, paymentStatus) => {
    const lowerStatus = getSafeLowerCase(status);
    const lowerPaymentStatus = getSafeLowerCase(paymentStatus);
    
    if (lowerStatus === 'refunded' || lowerStatus === 'cancelled') return 'refunded';
    if (lowerPaymentStatus === 'success' || lowerStatus === 'confirmed') return 'completed';
    if (lowerPaymentStatus === 'pending' || lowerStatus === 'pending') return 'pending';
    if (lowerPaymentStatus === 'failed') return 'failed';
    return 'pending';
  };

  const generatePageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, start + maxVisiblePages - 1);
      
      if (end - start + 1 < maxVisiblePages) {
        start = Math.max(1, end - maxVisiblePages + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  };

  // Loading state with skeletons
  if (loading && payments.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Payment Report</h1>
        <div className="header-actions">
          <form onSubmit={handleSearchSubmit} className="search-form">
            <div style={{ position: 'relative' }}>
              <input 
                type="text" 
                placeholder="Search by transaction or booking..." 
                className="search-input" 
                value={searchTerm}
                onChange={handleSearchChange}
                style={{ width: "300px" }}
              />
              {searching && (
                <span style={{
                  position: 'absolute', right: '10px', top: '50%',
                  transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
                }}>
                  searching...
                </span>
              )}
            </div>
          </form>
          <button className="filter-btn" onClick={toggleFilters}>
            🔍 Filters
          </button>
          <button className="refresh-btn" onClick={handleRefresh}>
            Refresh
          </button>
          <button className="export-btn" onClick={handleExportReport}>
            Export Report
          </button>
        </div>
      </div>

      {/* Filter Panel */}
      {showFilters && !loading && (
        <div className="filter-panel">
          <div className="filter-header">
            <h3>Filter Payments</h3>
            <button className="close-filters" onClick={() => setShowFilters(false)}>
              ×
            </button>
          </div>
          <div className="filter-grid">
            <div className="filter-group">
              <label>Transaction ID</label>
              <input
                type="text"
                name="transaction"
                value={filters.transaction}
                onChange={handleFilterChange}
                placeholder="Enter transaction ID"
              />
            </div>
            <div className="filter-group">
              <label>User Name</label>
              <input
                type="text"
                name="userName"
                value={filters.userName}
                onChange={handleFilterChange}
                placeholder="Enter user name"
              />
            </div>
            <div className="filter-group">
              <label>User Email</label>
              <input
                type="email"
                name="userEmail"
                value={filters.userEmail}
                onChange={handleFilterChange}
                placeholder="Enter user email"
              />
            </div>
            <div className="filter-group">
              <label>User Phone</label>
              <input
                type="text"
                name="userPhone"
                value={filters.userPhone}
                onChange={handleFilterChange}
                placeholder="Enter user phone"
              />
            </div>
            <div className="filter-group">
              <label>Booking ID</label>
              <input
                type="text"
                name="bookingId"
                value={filters.bookingId}
                onChange={handleFilterChange}
                placeholder="Enter booking ID"
              />
            </div>
            <div className="filter-group">
              <label>Payment Status</label>
              <select
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
              >
                <option value="All Status">All Status</option>
                <option value="Completed">Completed</option>
                <option value="Pending">Pending</option>
                <option value="Failed">Failed</option>
                <option value="Refunded">Refunded</option>
              </select>
            </div>
            <div className="filter-group">
              <label>Payment Method</label>
              <select
                name="method"
                value={filters.method}
                onChange={handleFilterChange}
              >
                <option value="All Methods">All Methods</option>
                <option value="Online">Online</option>
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="UPI">UPI</option>
              </select>
            </div>
            <div className="filter-group">
              <label>Payment From</label>
              <input
                type="date"
                name="startDate"
                value={filters.startDate}
                onChange={handleFilterChange}
              />
            </div>
            <div className="filter-group">
              <label>Payment To</label>
              <input
                type="date"
                name="endDate"
                value={filters.endDate}
                onChange={handleFilterChange}
              />
            </div>
            <div className="filter-group">
              <label>Min Amount</label>
              <input
                type="number"
                name="minAmount"
                value={filters.minAmount}
                onChange={handleFilterChange}
                placeholder="Minimum amount"
                min="0"
              />
            </div>
            <div className="filter-group">
              <label>Max Amount</label>
              <input
                type="number"
                name="maxAmount"
                value={filters.maxAmount}
                onChange={handleFilterChange}
                placeholder="Maximum amount"
                min="0"
              />
            </div>
          </div>
          <div className="filter-actions">
            <button className="apply-filters-btn" onClick={applyFilters}>
              Apply Filters
            </button>
            <button className="clear-filters-btn" onClick={clearFilters}>
              Clear All
            </button>
          </div>
          {isFiltered && (
            <div className="active-filters">
              <span>Active Filters:</span>
              {searchTerm && (
                <span className="filter-tag">Search: {searchTerm}</span>
              )}
              {filters.status !== 'All Status' && (
                <span className="filter-tag">Status: {filters.status}</span>
              )}
              {filters.method !== 'All Methods' && (
                <span className="filter-tag">Method: {filters.method}</span>
              )}
              {Object.entries(filters).map(([key, value]) => 
                value && 
                key !== 'status' && 
                key !== 'method' && 
                key !== 'startDate' && 
                key !== 'endDate' && (
                  <span key={key} className="filter-tag">
                    {key}: {value}
                  </span>
                )
              )}
              {filters.startDate && (
                <span className="filter-tag">From: {filters.startDate}</span>
              )}
              {filters.endDate && (
                <span className="filter-tag">To: {filters.endDate}</span>
              )}
            </div>
          )}
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="stats-cards">
        <div className="stat-card">
          <h3>Total Payments</h3>
          <p>{totalPayments}</p>
          <span>All transactions</span>
        </div>
        <div className="stat-card">
          <h3>Total Revenue</h3>
          <p>{formatCurrency(totalRevenue)}</p>
          <span>successful payments</span>
        </div>
        <div className="stat-card">
          <h3>Success Rate</h3>
          <p>{successRate}%</p>
          <span>{successfulPayments}/{totalPayments} payments</span>
        </div>
        <div className="stat-card">
          <h3>Search Results</h3>
          <p>{payments.length}</p>
          <span>payments found</span>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Transaction ID</th>
              <th>User</th>
              <th>Amount</th>
              <th>Method</th>
              <th>Date & Time</th>
              <th>Booking</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {payments.length > 0 ? (
              payments.map(payment => (
                <tr key={payment.id}>
                  <td className="transaction">{getSafeString(payment.transaction)}</td>
                  <td>
                    <div>
                      <div>{getSafeString(payment.user)}</div>
                      <div className="phone">{getSafeString(payment.userEmail)}</div>
                    </div>
                  </td>
                  <td>{formatCurrency(payment.amount)}</td>
                  <td>
                    <span className={`payment-method ${getSafeLowerCase(payment.method).replace(' ', '-')}`}>
                      {getSafeString(payment.method)}
                    </span>
                  </td>
                  <td>
                    <div>
                      <div>{getSafeString(payment.date)}</div>
                      <div className="phone">{getSafeString(payment.time)}</div>
                    </div>
                  </td>
                  <td>{getSafeString(payment.booking)}</td>
                  <td>
                    <span className={`status-badge ${getStatusBadgeClass(payment.status, payment.paymentStatus)}`}>
                      {getSafeString(payment.status === 'Confirmed' ? 'Completed' : payment.status)}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button 
                        className="action-btn view" 
                        onClick={() => handleViewPayment(payment)}
                      >
                        Details
                      </button>
                      {(getSafeLowerCase(payment.status) === 'pending' || getSafeLowerCase(payment.paymentStatus) === 'pending') && (
                        <button 
                          className="action-btn process" 
                          onClick={() => handleProcessPayment(payment)}
                        >
                          Process
                        </button>
                      )}
                      {(getSafeLowerCase(payment.status) === 'confirmed' || getSafeLowerCase(payment.paymentStatus) === 'success') && (
                        <button 
                          className="action-btn delete" 
                          onClick={() => handleRefundPayment(payment)}
                        >
                          Refund
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="no-data">
                  <p>No payments found {isFiltered ? 'matching your filters' : ''}.</p>
                  {isFiltered && (
                    <button className="clear-filters-link" onClick={clearFilters}>
                      Clear filters to see all payments
                    </button>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Component */}
      {totalPages > 1 && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {payments.length} of {totalPayments} payments
            (Page {currentPage} of {totalPages})
            {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
            {isFiltered && !searchTerm && <span className="filtered-indicator"> • Filtered Results</span>}
          </div>
          <div className="pagination-controls">
            <button 
              className="pagination-btn" 
              onClick={handlePrevPage}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            
            <div className="page-numbers">
              {generatePageNumbers().map(pageNumber => (
                <button
                  key={pageNumber}
                  className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                  onClick={() => handlePageClick(pageNumber)}
                >
                  {pageNumber}
                </button>
              ))}
              
              {totalPages > 5 && currentPage < totalPages - 2 && (
                <>
                  <span className="page-dots">...</span>
                  <button
                    className="page-number"
                    onClick={() => handlePageClick(totalPages)}
                  >
                    {totalPages}
                  </button>
                </>
              )}
            </div>
            
            <button 
              className="pagination-btn" 
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* View Payment Modal */}
      {viewingPayment && !isFetchingDetails && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Payment Details - {getSafeString(viewingPayment.transaction)}</h3>
              <button className="modal-close-btn" onClick={closeViewModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="customer-details">
                <div className="detail-row">
                  <label>Transaction ID:</label>
                  <span className="transaction">{getSafeString(viewingPayment.transaction)}</span>
                </div>
                <div className="detail-row">
                  <label>User:</label>
                  <span>{getSafeString(viewingPayment.user)}</span>
                </div>
                <div className="detail-row">
                  <label>Email:</label>
                  <span>{getSafeString(viewingPayment.userEmail)}</span>
                </div>
                <div className="detail-row">
                  <label>Phone:</label>
                  <span>{getSafeString(viewingPayment.userPhone)}</span>
                </div>
                <div className="detail-row">
                  <label>Amount:</label>
                  <span>{formatCurrency(viewingPayment.amount)}</span>
                </div>
                <div className="detail-row">
                  <label>Payment Method:</label>
                  <span className={`payment-method ${getSafeLowerCase(viewingPayment.method).replace(' ', '-')}`}>
                    {getSafeString(viewingPayment.method)}
                  </span>
                </div>
                <div className="detail-row">
                  <label>Date:</label>
                  <span>{getSafeString(viewingPayment.date)}</span>
                </div>
                <div className="detail-row">
                  <label>Time:</label>
                  <span>{getSafeString(viewingPayment.time)}</span>
                </div>
                <div className="detail-row">
                  <label>Booking Reference:</label>
                  <span>{getSafeString(viewingPayment.booking)}</span>
                </div>
                <div className="detail-row">
                  <label>Status:</label>
                  <span className={`status-badge ${getStatusBadgeClass(viewingPayment.status, viewingPayment.paymentStatus)}`}>
                    {getSafeString(viewingPayment.status === 'Confirmed' ? 'Completed' : viewingPayment.status)}
                  </span>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-close-btn secondary" onClick={closeViewModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for view modal */}
      {viewingPayment && isFetchingDetails && <SkeletonModal />}

      {/* Process Payment Modal */}
      {processingPayment && (
        <div className="modal-overlay" onClick={closeProcessModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Process Payment</h3>
              <button className="modal-close-btn" onClick={closeProcessModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="customer-details">
                <div className="detail-row">
                  <label>Transaction:</label>
                  <span className="transaction">{getSafeString(processingPayment.transaction)}</span>
                </div>
                <div className="detail-row">
                  <label>User:</label>
                  <span>{getSafeString(processingPayment.user)}</span>
                </div>
                <div className="detail-row">
                  <label>Amount:</label>
                  <span>{formatCurrency(processingPayment.amount)}</span>
                </div>
                <div className="detail-row">
                  <label>Booking:</label>
                  <span>{getSafeString(processingPayment.booking)}</span>
                </div>
                <div className="detail-row">
                  <label>Current Status:</label>
                  <span className="status-badge pending">Pending</span>
                </div>
                <div className="detail-row">
                  <label>Action:</label>
                  <span>Mark as Completed</span>
                </div>
              </div>
              <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#f0f9ff', borderRadius: '8px'}}>
                <p style={{margin: '0', color: '#0369a1', fontSize: '14px'}}>
                  <strong>Note:</strong> This will mark the payment as completed and confirm the associated booking.
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={closeProcessModal}>
                Cancel
              </button>
              <button className="action-btn process" onClick={handleConfirmProcess}>
                Confirm Process
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Refund Payment Modal */}
      {refundingPayment && (
        <div className="modal-overlay" onClick={closeRefundModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Refund Payment</h3>
              <button className="modal-close-btn" onClick={closeRefundModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="customer-details">
                <div className="detail-row">
                  <label>Transaction:</label>
                  <span className="transaction">{getSafeString(refundingPayment.transaction)}</span>
                </div>
                <div className="detail-row">
                  <label>User:</label>
                  <span>{getSafeString(refundingPayment.user)}</span>
                </div>
                <div className="detail-row">
                  <label>Original Amount:</label>
                  <span>{formatCurrency(refundingPayment.amount)}</span>
                </div>
                <div className="detail-row">
                  <label>Booking:</label>
                  <span>{getSafeString(refundingPayment.booking)}</span>
                </div>
                
                <div className="detail-row">
                  <label>Refund Amount:</label>
                  <input
                    type="number"
                    value={refundAmount}
                    onChange={(e) => setRefundAmount(e.target.value)}
                    placeholder="Enter refund amount"
                    style={{padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '200px'}}
                  />
                </div>
                
                <div className="detail-row">
                  <label>Refund Reason:</label>
                  <textarea
                    value={refundReason}
                    onChange={(e) => setRefundReason(e.target.value)}
                    placeholder="Enter reason for refund"
                    style={{padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '200px', minHeight: '60px'}}
                  />
                </div>
              </div>
              <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px'}}>
                <p style={{margin: '0', color: '#856404', fontSize: '14px'}}>
                  <strong>Warning:</strong> This action will cancel the booking and process a refund. This cannot be undone.
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={closeRefundModal}>
                Cancel
              </button>
              <button className="action-btn delete" onClick={handleConfirmRefund}>
                Confirm Refund
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentReport;